import { debounce } from "lodash";
import { useEffect, useState } from "react";

import { ApiManager } from "services/api";

const fetchAddressesCall = async (type: "requester" | "cc", fragment: string): Promise<string[]> => {
  const response = await ApiManager.addressesApi.fetchAddresses({ type, fragment });

  if (response.error) {
    return [];
  }

  return response.result.map(address => address.email);
};

export const useDebouncedAddresses = (
  type: "requester" | "cc",
  fragment: string,
  debounceMs: number = 200
): string[] => {
  const [addresses, setAddresses] = useState<string[]>([]);

  useEffect(() => {
    const debouncedFetchAddresses = debounce(async (type: "requester" | "cc", fragment: string) => {
      const result = await fetchAddressesCall(type, fragment);
      setAddresses(result);
    }, debounceMs);

    if (fragment.length < 3) {
      setAddresses([]);
      return;
    }

    debouncedFetchAddresses(type, fragment);

    return (): void => {
      debouncedFetchAddresses.cancel();
    };
  }, [type, fragment]);

  return addresses;
};
